import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../components/ui';
import { CharacterCard, Character } from '../components/CharacterCard';
const FULL_CAST: Character[] = [{
  id: 'vinny',
  name: 'Vinny Capuano',
  hometown: 'Brooklyn, NY',
  color: 'bg-blue-900',
  borderColorClass: 'border-blue-500',
  quote: "Whaddya think you're doin' startin' Deebo on a BYE week? You stunad.",
  bio: "Vinny runs a deli in Bensonhurst and hasn't missed a Sunday kickoff since 1998. He thinks analytics are ruining the game and believes every problem can be solved by 'running the damn ball.'",
  catchphrases: ['You stunad!', 'Fuhgeddaboudit.', 'My grandmother could run a better route.']
}, {
  id: 'dale',
  name: 'Dale & Earl',
  hometown: 'Harlan County, KY',
  color: 'bg-green-900',
  borderColorClass: 'border-green-600',
  quote: "Well I'll be dadgum... you started WHO? Boy, even the mule woulda known better.",
  bio: "Two cousins sharing one microphone from the cab of a 1994 Ford F-150. They measure player performance in 'horsepower' and 'grit'.",
  catchphrases: ['Lord have mercy.', "That boy's softer than a sneaker full of puppy poop.", 'Earl, get the jumper cables.']
}, {
  id: 'marisol',
  name: 'Marisol Cruz',
  hometown: 'San Juan, PR',
  color: 'bg-rose-900',
  borderColorClass: 'border-rose-500',
  quote: 'Ay, mira — Josh Allen casi me da un ataque al corazón. Casi. CASI, David!',
  bio: "Your extremely passionate, slightly terrifying aunt who somehow knows more about defensive schemes than the actual coaches. She will pray for your team, but mostly she'll just yell.",
  catchphrases: ['¡Dios mío!', 'You call that a tackle?', "I'm lighting a candle for your roster."]
}, {
  id: 'giuseppe',
  name: 'Giuseppe Conti',
  hometown: 'Palermo, Sicily',
  color: 'bg-red-950',
  borderColorClass: 'border-red-800',
  quote: '...You benched Jefferson. (long pause) ...I have nothing more to say to you.',
  bio: "A man of few words, but immense disappointment. Giuseppe doesn't yell. He just makes you feel profound, existential shame about your flex spot.",
  catchphrases: ['*Heavy sigh*', 'This is a dishonor.', 'We do not speak of this week.']
}, {
  id: 'daniel',
  name: 'Daniel Ashworth',
  hometown: 'London, UK',
  color: 'bg-slate-800',
  borderColorClass: 'border-slate-400',
  quote: "I've watched 40 years of rugby. Nothing prepared me for this level of suffering.",
  bio: 'A proper English gentleman trying to understand American football. He treats every fumble like a national tragedy and every touchdown like a mild inconvenience.',
  catchphrases: ['Absolute rubbish.', "What on earth is a 'flea flicker'?", 'I need a pint after that.']
}, {
  id: 'gary',
  name: "G'Day Gary",
  hometown: 'Melbourne, AU',
  color: 'bg-orange-900',
  borderColorClass: 'border-orange-500',
  quote: 'STREWTH mate, that was more painful than a box jellyfish to the face! RIPPER matchup!',
  bio: 'Gary is always at a volume of 11. He thinks pads are for cowards and treats fantasy football like a blood sport.',
  catchphrases: ['CRIKEY!', 'Put another shrimp on the barbie, your team is cooked!', 'Absolute madness!']
}, {
  id: 'ricky',
  name: 'Ricky Rotardo',
  hometown: 'Parts Unknown',
  color: 'bg-yellow-900',
  borderColorClass: 'border-yellow-400',
  quote: "Every week I watch you self-destruct and every week I'm NEVER disappointed.",
  bio: 'The villain of the platform. Ricky actively roots against you, celebrates your injuries, and thrives on your misery. Unlocked at Tier 3.',
  catchphrases: ['Delicious tears.', 'I hope you lose by 0.1 points.', 'Your suffering sustains me.']
}, {
  id: 'chad',
  name: 'Chad "The Bro"',
  hometown: 'Scottsdale, AZ',
  color: 'bg-cyan-900',
  borderColorClass: 'border-cyan-400',
  quote: 'Bro, your lineup is looking totally un-chill right now. Vibes are atrocious.',
  bio: "Finance bro who drafted his team based entirely on crypto advice. He's not mad you lost, he's just disappointed in your portfolio diversification.",
  catchphrases: ['Not cash money.', 'Diamond hands on that waiver wire.', 'Vibe check: failed.']
}, {
  id: 'coach',
  name: 'Coach Miller',
  hometown: 'Odessa, TX',
  color: 'bg-zinc-800',
  borderColorClass: 'border-zinc-500',
  quote: "TAKE A LAP! I've seen better clock management from a broken sundial!",
  bio: 'A retired high school football coach who treats your fantasy team like a varsity squad that just fumbled on the 1-yard line.',
  catchphrases: ['Fundamentals!', "You're killing me, Smalls!", 'Drop and give me twenty!']
}, {
  id: 'karen',
  name: 'Karen',
  hometown: 'Suburbs, USA',
  color: 'bg-fuchsia-900',
  borderColorClass: 'border-fuchsia-400',
  quote: "I'd like to speak to the manager of the NFL. This scoring is completely unacceptable.",
  bio: "She doesn't understand the rules, but she knows she's being treated unfairly. Will threaten to sue the commissioner over a stat correction.",
  catchphrases: ['This is ridiculous.', 'Who is in charge here?', "I'm calling the police."]
}];
const JORGE: Character = {
  id: 'jorge',
  name: 'Jorge (The Interrupt)',
  hometown: 'Mexico City, MX',
  color: 'bg-red-600',
  borderColorClass: 'border-red-500',
  quote: '—¡NO MAMES! ¡TOUCHDOWN! ¡TOUCHED—',
  bio: "Jorge doesn't wait his turn. He is a special mechanic that randomly interrupts other commentators during massive plays or catastrophic fumbles.",
  catchphrases: ['¡GOLAZO!', '¡Ay caramba!', '¡No puede ser!'],
  isInterrupt: true
};
export const CharactersPage = () => {
  return <div className="w-full pt-20" data-id="element-162">
      {/* HERO */}
      <section className="py-24 bg-stadium-grain bg-cover bg-center relative border-b border-white/10" data-id="element-163">
        <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" data-id="element-164"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-165">
          <SectionHeading title="THE CAST" subtitle="11 distinct voices. Infinite ways to get roasted. Build your perfect commentary booth." className="mb-0 mx-auto flex flex-col items-center" data-id="element-166" />
        </div>
      </section>

      {/* GRID */}
      <section className="py-24 bg-charcoal" data-id="element-167">
        <div className="container mx-auto px-4" data-id="element-168">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-id="element-169">
            {FULL_CAST.map(char => <CharacterCard key={char.id} character={char} expanded={true} data-id="element-170" />)}
          </div>
        </div>
      </section>

      {/* THE INTERRUPT SECTION */}
      <section className="py-24 bg-dark border-y border-white/10 relative overflow-hidden" data-id="element-171">
        <div className="absolute inset-0 bg-red-900/10" data-id="element-172"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-173">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-174">
            <div className="lg:w-1/2" data-id="element-175">
              <h2 className="text-sm font-bold uppercase tracking-wider text-red-500 mb-4" data-id="element-176">
                Special Mechanic
              </h2>
              <h3 className="text-5xl md:text-7xl font-black font-heading uppercase -skew-x-6 mb-6 text-white" data-id="element-177">
                PLUS: THE INTERRUPT
              </h3>
              <p className="text-xl text-slate mb-8" data-id="element-178">
                Jorge doesn't wait his turn. When a massive 50+ yard play
                happens, or someone fumbles on the goal line, Jorge will
                literally cut off the other commentators mid-sentence.
              </p>
              <div className="bg-charcoal p-6 rounded-2xl border border-white/10 relative" data-id="element-179">
                <p className="text-slate italic mb-2" data-id="element-180">Audio transcript:</p>
                <p className="text-white font-medium" data-id="element-181">
                  <span className="text-blue-400" data-id="element-182">Vinny:</span> "Look, I told
                  you not to start him, he's got hands like frying pa—"
                </p>
                <p className="text-red-500 font-bold text-xl mt-2 animate-pulse" data-id="element-183">
                  <span className="text-white" data-id="element-184">Jorge:</span> "¡NO MAMES!
                  ¡TOUCHDOWN DE OCHENTA YARDAS! ¡VÁMONOS!"
                </p>
              </div>
            </div>
            <div className="lg:w-1/2 w-full max-w-md" data-id="element-185">
              <CharacterCard character={JORGE} expanded={true} data-id="element-186" />
            </div>
          </div>
        </div>
      </section>

      {/* SPANGLISH SIDEBAR */}
      <section className="py-24 bg-charcoal" data-id="element-187">
        <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-188">
          <h2 className="text-4xl md:text-6xl font-black font-heading uppercase -skew-x-6 mb-6 text-lime" data-id="element-189">
            SPANGLISH SIDEBAR
          </h2>
          <p className="text-xl text-slate mb-12" data-id="element-190">
            Pair Marisol and Jorge together to unlock the "Spanglish Sidebar" —
            a special commentary mode where they argue with each other in two
            languages while completely ignoring your fantasy score.
          </p>
          <div className="flex justify-center gap-4" data-id="element-191">
            <div className="w-20 h-20 rounded-full bg-rose-900 border-2 border-rose-500 flex items-center justify-center text-2xl font-black font-heading" data-id="element-192">
              M
            </div>
            <div className="flex items-center text-lime font-bold text-2xl" data-id="element-193">
              +
            </div>
            <div className="w-20 h-20 rounded-full bg-red-600 border-2 border-red-500 flex items-center justify-center text-2xl font-black font-heading" data-id="element-194">
              J
            </div>
          </div>
        </div>
      </section>
    </div>;
};